// NOTE: components
import Skeleton from '../../components/ui/Skeleton'

// NOTE: the masonry columns need uneven cover heights to read as cards instead of a grid
const CARD_PLACEHOLDERS = [
	{ id: 'first', className: 'h-[260px]' },
	{ id: 'second', className: 'h-[180px]' },
	{ id: 'third', className: 'h-[320px]' }
]

const TAB_PLACEHOLDERS = [
	'all',
	'corporate',
	'clinic'
]

const ContentsSkeleton = () => (
	<div role="status" aria-label="Loading contents">
		{/* Header */}
		<section className="bg-white">
			<div className="mx-auto w-full max-w-7xl px-5 pt-10 sm:px-8">
				<Skeleton className="mx-auto mb-1 h-[42px] w-[260px] sm:h-12 sm:w-[340px] md:h-16 md:w-[420px]" />

				<div className="mx-auto mt-5 max-w-[480px]">
					<Skeleton className="mb-2.5 h-5 w-full" />
					<Skeleton className="mx-auto mb-8 h-5 w-3/4" />
				</div>

				<div className="mb-4 flex justify-center gap-4">
					{TAB_PLACEHOLDERS.map((tab) => (
						<Skeleton key={tab} className="h-8 w-[90px]" />
					))}
				</div>
			</div>
		</section>

		{/* Contents */}
		<section className="bg-white">
			<div className="mx-auto w-full max-w-7xl px-5 pb-16 sm:px-8">
				<div className="columns-1 gap-4 sm:columns-2 lg:columns-3">
					{CARD_PLACEHOLDERS.map(({ id, className }) => (
						<div
							key={id}
							className="mb-10 overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-lift sm:mb-6"
						>
							<Skeleton className={`w-full rounded-none ${className}`} />

							<div className="p-6">
								<Skeleton className="mb-3 h-4 w-[110px]" />
								<Skeleton className="mb-3 h-6 w-4/5" />

								<Skeleton className="mb-2.5 h-4 w-full" />
								<Skeleton className="mb-6 h-4 w-2/3" />

								<Skeleton className="ml-auto h-4 w-[110px]" />
							</div>
						</div>
					))}
				</div>
			</div>
		</section>
	</div>
)

export default ContentsSkeleton
